export default {
	blueprint: [
		{
			key: ["price"],
			name: "Price",
			type: "min_max_price",
		},
	],
}
